import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import productsImages from "../data/products.json";

function ProductProp() {
	const { productName } = useParams();
	const displayName = decodeURIComponent(productName || "");
	const images = productsImages[productName] || productsImages[displayName];
	const [isVisible, setIsVisible] = useState(false);

	const handleScroll = () => {
		if (window.scrollY > 300) {
			setIsVisible(true);
		} else {
			setIsVisible(false);
		}
	};

	const scrollToTop = () => {
		window.scrollTo({ top: 0, behavior: "smooth" });
	};

	useEffect(() => {
		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);

	return (
		<div>
			<h2 className="text-center text-3xl font-bold text-gray-900">
				{displayName}
			</h2>
			<div className="mt-6 flex flex-wrap">
				{images ? (
					images.map((image, index) => (
						<img
							key={index}
							src={process.env.PUBLIC_URL + image}
							alt={`${displayName} ${index + 1}`}
							className="h-auto max-w-full"
						/>
					))
				) : (
					<p>No images available for this product.</p>
				)}
			</div>
			{isVisible && (
				<button
					onClick={scrollToTop}
					className="fixed bottom-5 right-5 rounded bg-primary px-3 py-2 font-overpass text-white"
				>
					<i className="fas fa-arrow-up"></i> Scroll to Top
				</button>
			)}
		</div>
	);
}

export default ProductProp;
